<template>
  <div class="colBox">
    <div class="colTit">
      {{ votelistData.module_name }}<span class="icoHot"></span>
    </div>
    <ul class="voteList">
      <li v-for="item in votelistData.user_candidates" :key="item.id">
        <div class="pic">
          <span class="icoPlay" v-if="item.rlVideoId"></span>
          <van-image :src="item.avatar" />
        </div>
        <a
          href="https://a.app.qq.com/o/simple.jsp?pkgname=com.v1.video"
          class="voteBtn fr"
          v-if="!item.isDeadline"
          >投票</a
        >
        <a
          href="https://a.app.qq.com/o/simple.jsp?pkgname=com.v1.video"
          class="voteBtn disabled fr"
          v-else
          >已结束</a
        >
        <div class="txt">
          <div>
            <span class="num"
              >{{ item.serialNumber }}
              <i
                v-if="
                  item.serialNumber != '' &&
                  typeof item.serialNumber != 'undefined'
                "
                >|</i
              > </span
            ><span class="name van-ellipsis">{{ item.username }}</span
            ><span class="city">{{ item.address }}</span>
          </div>
          <div class="van-ellipsis company">{{ item.attachedUnits }}</div>
        </div>
        <div class="votes">{{ item.votenum }}票</div>
      </li>
    </ul>
    <a
      href="https://a.app.qq.com/o/simple.jsp?pkgname=com.v1.video"
      class="more"
      >查看全部</a
    >
  </div>
</template>
<script>
import { Image as VanImage } from "vant";
export default {
  name: "votelist", //投票环节
  components: { VanImage },
  props: ["votelistData"],
  data() {
    return {
      votelist: [],
    };
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>
<style scoped>
.btn {
  display: block;
  width: 79px;
  height: 38px;
  bottom: 10px;
  right: 15px;
  background: url(../../assets/images/btn_bg.png) no-repeat 0 0;
  background-size: 100%;
  text-align: center;
  line-height: 38px;
  color: #ffffff;
}
span i {
  font-style: normal;
}
.aboutBtn {
  display: block;
  float: right;
  font-size: 12px;
  color: #999999;
}

.icoPlay {
  display: block;
  width: 14px;
  height: 14px;
  background: url(../../assets/images/icon_play.png) no-repeat 0 0;
  background-size: 14px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  z-index: 1;
}

.txt {
  overflow: hidden;
  line-height: 18px;
  padding-top: 5px;
}
.num,
.name {
  color: #333333;
  font-weight: bold;
  display: inline-block;
  max-width: 100px;
  overflow: hidden;
  vertical-align: top;
}
.city {
  display: inline-block;
  color: #999999;
  font-size: 12px;
  padding-left: 10px;
  vertical-align: top;
}
.company {
  color: #666666;
  font-size: 12px;
}
.voteBtn {
  margin-top: 5px;
}
.votes {
  clear: both;
  padding-left: 5px;
  margin-top: 3px;
  background: linear-gradient(180deg, #fad961, #f76b1c 73%);
  font-size: 12px;
  color: #f76b1c;
  font-weight: bold;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>